import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_COMPANY_WEEKDAYS:
      return { ..._.mapKeys(action.payload, "CompanyId") };
    // return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_COMPANY_WEEKDAYS:
      return { ...state, [action.payload.Id]: action.payload };
    default:
      return state;
  }
};
